import { useTranslation } from 'react-i18next'
import Text from 'components/priority/Text/Text'
import type { EnhanceLayout } from './EnhancePanel.styled'
import { CASE_IMAGES_TEST_IDS } from './caseImagesTestIds'

type EnhanceGenerativeNoticeProps = {
  /** The host the panel is drawn in; the modal sets its copy tighter. */
  layout: EnhanceLayout
  /** Centre the text, as the modal's complete stage centres its copy. */
  centred?: boolean
}

/**
 * The client's agreed notice that generative upscaling invents new detail
 * and can occasionally change faces, skin or background. `EnhancePanel`
 * shows it on the disclosure, before anything runs, and again on the
 * complete stage, before the billable accept, because the disclosure is
 * skipped once a person has dismissed it. It reads as one more paragraph of
 * the disclosure copy, the way the Remove Background disclosure states its
 * caveat in its body.
 */
export const EnhanceGenerativeNotice = ({
  layout,
  centred = false,
}: EnhanceGenerativeNoticeProps) => {
  const { t } = useTranslation()
  const modal = layout === 'modal'
  return (
    <Text
      size="14px"
      weight={modal ? '500' : undefined}
      color="gray2"
      line={modal ? '16px' : '1.5'}
      align={centred ? 'center' : undefined}
      data-testid={CASE_IMAGES_TEST_IDS.ENHANCE_GENERATIVE_NOTICE}
    >
      {t('caseImages.enhance.generativeNotice')}
    </Text>
  )
}
